<template>
  <div v-if="$whitelabel.showHeader">
    <section class="hero hero-about__wrapper hero-header has-background-grey-light has-no-background-print" :style="cssProps">
      <div class="hero-body has-text-centered">
        <h1 class="title title--hero mb-5 is-size-2" v-html="$whitelabel.heroTitle"></h1>
        <p class="subtitle is-size-7 has-text-weight-bold">
          <span v-if="!$whitelabel.poweredByText"
            >powered by <span class="is-sr-only"><br />we-are.travel</span></span
          >
          <span v-if="$whitelabel.poweredByText" v-html="$whitelabel.poweredByText"></span>
          <img class="subtitle-img" :src="'https://assets.urlaubsgutschein.kaufen/whitelabel/we-are.travel.svg'" alt="we-are.travel" fetchpriority="high" width="351" height="70" />
        </p>

        <!-- <div class="notification hero-subtext" v-show="$route.path === '/'">
          Egal ob ein exklusiver Wellnessurlaub, eine tolle Städtereise oder ein unvergesslicher Wanderurlaub in den Bergen – mit einem Urlaubsgutschein finden Sie das richtige Angebot mit bis zu 70% Ersparnis. Die Gutscheine sind bis zu 3 Jahre gültig und auch ideal als Geschenk geeignet.
          <router-link to="/gutscheinvorteile" class="is-inline-block"><i class="fas fa-angle-double-right"></i> Ihre Gutscheinvorteile </router-link>
        </div> -->

        <!-- <p class="has-background-white u-p05 u-w80ch" v-if="$whitelabel.heroInfoText" v-html="$whitelabel.heroInfoText">
            </p>         -->

        <p class="hero-subtext is-hidden-touch" v-if="$whitelabel.heroInfoText">
          <span class="hero-subtext-content has-background-white" v-html="$whitelabel.heroInfoText"></span>
        </p>

        <HeroBadge />
      </div>
    </section>
  </div>
</template>

<script>
import HeroBadge from '@/components/HeroBadge'

export default {
  name: 'HeroInfoStandalone',
  components: {
    HeroBadge,
  },
  metaInfo() {
    return {
      link: [
        // {
        //   rel: 'preload',
        //   href: `https://assets.urlaubsgutschein.kaufen/i/crop?width=${this.$whitelabel.heroImageResolution.xs.width}&height=${this.$whitelabel.heroImageResolution.xs.height}&gravity=${this.$whitelabel.heroImageResolution.xs.crop}&quality=50&interlace=true&type=auto&file=${this.$whitelabel.assetUrl}hero.jpg`,
        //   crossorigin: 'anonymous',
        //   as: 'image',
        //   imagesizes: '100vw',
        //   imagesrcset: `https://assets.urlaubsgutschein.kaufen/i/crop?width=${this.$whitelabel.heroImageResolution.xl.width}&height=${this.$whitelabel.heroImageResolution.xl.height}&gravity=${this.$whitelabel.heroImageResolution.xl.crop}&quality=50&interlace=true&type=auto&file=${this.$whitelabel.assetUrl}hero.jpg 1418w,
        //   https://assets.urlaubsgutschein.kaufen/i/crop?width=${this.$whitelabel.heroImageResolution.l.width}&height=${this.$whitelabel.heroImageResolution.l.height}&gravity=${this.$whitelabel.heroImageResolution.l.crop}&quality=50&interlace=true&type=auto&file=${this.$whitelabel.assetUrl}hero.jpg 1216w,
        //   https://assets.urlaubsgutschein.kaufen/i/crop?width=${this.$whitelabel.heroImageResolution.m.width}&height=${this.$whitelabel.heroImageResolution.m.height}&gravity=${this.$whitelabel.heroImageResolution.m.crop}&quality=50&interlace=true&type=auto&file=${this.$whitelabel.assetUrl}hero.jpg 960w,
        //   https://assets.urlaubsgutschein.kaufen/i/crop?width=${this.$whitelabel.heroImageResolution.s.width}&height=${this.$whitelabel.heroImageResolution.s.height}&gravity=${this.$whitelabel.heroImageResolution.s.crop}&quality=50&interlace=true&type=auto&file=${this.$whitelabel.assetUrl}hero.jpg 768w,
        //   https://assets.urlaubsgutschein.kaufen/i/crop?width=${this.$whitelabel.heroImageResolution.xs.width}&height=${this.$whitelabel.heroImageResolution.xs.height}&gravity=${this.$whitelabel.heroImageResolution.xs.crop}&quality=50&interlace=true&type=auto&file=${this.$whitelabel.assetUrl}hero.jpg 500w`,
        // },
        {
          rel: 'preload',
          href: `https://assets.urlaubsgutschein.kaufen/i/crop?width=${this.$whitelabel.heroImageResolution.xs.width}&height=${this.$whitelabel.heroImageResolution.xs.height}&gravity=${this.$whitelabel.heroImageResolution.xs.crop}&quality=50&interlace=true&type=auto&file=${this.$whitelabel.assetUrl}hero.jpg`,
          crossorigin: 'anonymous',
          as: 'image',
          media: '(max-width: 768px)',
        },
        {
          rel: 'preload',
          href: `https://assets.urlaubsgutschein.kaufen/i/crop?width=${this.$whitelabel.heroImageResolution.s.width}&height=${this.$whitelabel.heroImageResolution.s.height}&gravity=${this.$whitelabel.heroImageResolution.s.crop}&quality=50&interlace=true&type=auto&file=${this.$whitelabel.assetUrl}hero.jpg`,
          crossorigin: 'anonymous',
          as: 'image',
          media: '(min-width: 769px) and (max-width: 960px)',
        },
        {
          rel: 'preload',
          href: `https://assets.urlaubsgutschein.kaufen/i/crop?width=${this.$whitelabel.heroImageResolution.m.width}&height=${this.$whitelabel.heroImageResolution.m.height}&gravity=${this.$whitelabel.heroImageResolution.m.crop}&quality=50&interlace=true&type=auto&file=${this.$whitelabel.assetUrl}hero.jpg`,
          crossorigin: 'anonymous',
          as: 'image',
          media: '(min-width: 961px) and (max-width: 1216px)',
        },
        {
          rel: 'preload',
          href: `https://assets.urlaubsgutschein.kaufen/i/crop?width=${this.$whitelabel.heroImageResolution.l.width}&height=${this.$whitelabel.heroImageResolution.l.height}&gravity=${this.$whitelabel.heroImageResolution.l.crop}&quality=50&interlace=true&type=auto&file=${this.$whitelabel.assetUrl}hero.jpg`,
          crossorigin: 'anonymous',
          as: 'image',
          media: '(min-width: 1217px) and (max-width: 1418px)',
        },
        {
          rel: 'preload',
          href: `https://assets.urlaubsgutschein.kaufen/i/crop?width=${this.$whitelabel.heroImageResolution.xl.width}&height=${this.$whitelabel.heroImageResolution.xl.height}&gravity=${this.$whitelabel.heroImageResolution.xl.crop}&quality=50&interlace=true&type=auto&file=${this.$whitelabel.assetUrl}hero.jpg`,
          crossorigin: 'anonymous',
          as: 'image',
          media: '(min-width: 1419px)',
        },
      ],
    }
  },
  data() {
    return {
      cssProps: {
        backgroundImage: `url(https://assets.urlaubsgutschein.kaufen/i/crop?width=${this.$whitelabel.heroImageResolution.xs.width}&height=${this.$whitelabel.heroImageResolution.xs.height}&gravity=${this.$whitelabel.heroImageResolution.xs.crop}&quality=50&interlace=true&type=auto&file=${this.$whitelabel.assetUrl}hero.jpg)`,
      },
    }
  },

  methods: {
    onResize() {
      let width = window.innerWidth

      switch (true) {
        case width > 1418:
          this.cssProps.backgroundImage = `url(https://assets.urlaubsgutschein.kaufen/i/crop?width=${this.$whitelabel.heroImageResolution.xl.width}&height=${this.$whitelabel.heroImageResolution.xl.height}&gravity=${this.$whitelabel.heroImageResolution.xl.crop}&quality=50&interlace=true&type=auto&file=${this.$whitelabel.assetUrl}hero.jpg)`
          break
        case width > 1216:
          this.cssProps.backgroundImage = `url(https://assets.urlaubsgutschein.kaufen/i/crop?width=${this.$whitelabel.heroImageResolution.l.width}&height=${this.$whitelabel.heroImageResolution.l.height}&gravity=${this.$whitelabel.heroImageResolution.l.crop}&quality=50&interlace=true&type=auto&file=${this.$whitelabel.assetUrl}hero.jpg)`
          break
        case width > 960:
          this.cssProps.backgroundImage = `url(https://assets.urlaubsgutschein.kaufen/i/crop?width=${this.$whitelabel.heroImageResolution.m.width}&height=${this.$whitelabel.heroImageResolution.m.height}&gravity=${this.$whitelabel.heroImageResolution.m.crop}&quality=50&interlace=true&type=auto&file=${this.$whitelabel.assetUrl}hero.jpg)`
          break
        case width > 768:
          this.cssProps.backgroundImage = `url(https://assets.urlaubsgutschein.kaufen/i/crop?width=${this.$whitelabel.heroImageResolution.s.width}&height=${this.$whitelabel.heroImageResolution.s.height}&gravity=${this.$whitelabel.heroImageResolution.s.crop}&quality=50&interlace=true&type=auto&file=${this.$whitelabel.assetUrl}hero.jpg)`
          break
        case width > 500:
          this.cssProps.backgroundImage = `url(https://assets.urlaubsgutschein.kaufen/i/crop?width=${this.$whitelabel.heroImageResolution.xs.width}&height=${this.$whitelabel.heroImageResolution.xs.height}&gravity=${this.$whitelabel.heroImageResolution.xs.crop}&quality=50&interlace=true&type=auto&file=${this.$whitelabel.assetUrl}hero.jpg)`
          break
      }
    },
  },

  created() {
    this.onResize()
    window.addEventListener('resize', this.onResize)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
}
</script>

<style scoped lang="scss">
$padding: 0.3rem;

.hero {
  background-size: cover;
  display: flex;
  align-items: center;
  position: relative;
}

.hero-body {
  padding-bottom: 4rem;
  padding-top: 4rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 200px;
  position: relative;

  @media screen and (min-width: 960px) {
    height: 300px;
  }
}

.title,
.subtitle {
  background: #fff;
  display: inline-block;
  //flex: 0 1 auto;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.title {
  padding: $padding;
  z-index: 1;
}

.subtitle {
  display: flex;
  align-items: center;
  padding: 0.5rem;
  position: relative;
  top: -0.5rem;
}

.subtitle-img {
  height: 24px;
  width: auto;
}

.hero-subtext-content {
  line-height: 2;
  padding: $padding 0;
  line-height: 2.1;
  box-shadow: $padding 0 0 #fff, -$padding 0 0 #fff;
  box-decoration-break: clone;
  position: relative;
  left: $padding;
}

.hero-subtext {
  max-width: 90ch;
  margin-bottom: 1rem;
}

@media screen and (max-width: 480px) {
  .title {
    font-size: 1.8rem !important;
  }

  .subtitle {
    font-size: 0.9rem;
  }

  // .hero-subtext {
  //   font-size: 0.85rem;
  // }
}
</style>
